module.exports = __webpack_public_path__ + "static/media/vfriend.ef94b138.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/vfriend.png
// module id = 359
// module chunks = 0